<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            bottom left
            origin="top right"
            transition="scale-transition"
            offset-y>

            <template v-slot:activator="{ on }">
                <v-btn min-width="0" text v-on="on" @dblclick="onDblClick_Refresh">
                    <v-icon> mdi-filter-outline</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline">
                    <p class="pl-7 mb-8 mt-8">
                        Search Hotels
                    </p>
                </v-card-title>

                <v-form>
                    <!-- >>> Form, Fields -->
                    <v-list>
                        <v-list-item>
                            <v-combobox
                                v-model="input_country"
                                :items="get_Countries"
                                item-text="name"
                                item-value="id"
                                label="Select Country"
                                prepend-icon="mdi-map-marker"
                                clearable
                                small-chips>
                            </v-combobox>
                        </v-list-item>


                        <v-list-item>
                            <v-text-field
                                v-model="input_city"
                                label="Select one City"
                                prepend-icon="mdi-map-marker"
                                clearable
                                small-chips>
                            </v-text-field>
                        </v-list-item>


                        <v-list-item>
                            <v-combobox
                                v-model="input_Associated_Airport"
                                :items="get_AirportTaxes"
                                item-text="aptCode"
                                item-value="aptCode"
                                label="Select Associated Airport"
                                prepend-icon="mdi-airplane"
                                clearable
                                small-chips>
                            </v-combobox>
                        </v-list-item>


                        <v-list-item>
                            <v-combobox
                                v-model="input_shuttle"
                                :items="shuttleOptions"
                                label="Select Shuttle availability"
                                prepend-icon="mdi-account-details"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>

                        <v-list-item>
                            <v-combobox
                                v-model="status"
                                :items="statusItems"
                                label="Select one/more Status"
                                prepend-icon="mdi-account-details"
                                clearable
                                multiple
                                small-chips>
                            </v-combobox>
                        </v-list-item>


                        <v-list-item>
                            <template>
                                <v-card
                                    flat
                                    color="transparent"
                                    width="100%">
                                    <v-subheader style="padding-left:33px;height:auto;">
                                        <p style="margin:0;font-size:0.78rem;margin-top:6px;color:rgba(0,0,0,0.3);">
                                            Select Hotel price range
                                        </p>
                                    </v-subheader>

                                    <v-card-text>
                                    <v-row>
                                        <v-col style="padding-left:13px;padding-right:13px;padding-top:0;">
                                        <v-range-slider
                                            v-model="input_rangeHotelCost"
                                            :max="input_maxHotelCost"
                                            :min="input_minHotelCost"
                                            hide-details
                                            class="align-center">
                                                <template v-slot:prepend>
                                                    <v-text-field
                                                        :value="input_rangeHotelCost[0]"
                                                        class="mt-0 pt-0"
                                                        hide-details
                                                        single-line
                                                        type="number"
                                                        style="width: 80px"
                                                        @change="$set(input_rangeHotelCost, 0, $event)"
                                                        prepend-icon="mdi-cash-multiple"
                                                    ></v-text-field>
                                                </template>
                                                <template v-slot:append>
                                                    <v-text-field
                                                        :value="input_rangeHotelCost[1]"
                                                        class="mt-0 pt-0"
                                                        hide-details
                                                        single-line
                                                        type="number"
                                                        style="width: 60px"
                                                        @change="$set(input_rangeHotelCost, 1, $event)">
                                                    </v-text-field>
                                                </template>
                                        </v-range-slider>
                                        </v-col>
                                    </v-row>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </v-list-item>
                    </v-list>
                    <!-- <<< Form, Fields -->



                    <!-- >>> Action Buttons -->
                    <v-card-actions style="padding-bottom:10px;">
                        <v-spacer></v-spacer>
                        <v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
                        <v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onValidate"> Search</v-btn>
                    </v-card-actions>
                    <!-- <<< Action Buttons -->
                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>


<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';


    export default {
		name: 'PeopleFilterMenue',

		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				menu: false,
                input_country: '',
                input_city: '',
                input_shuttle: [
                    'Yes',
                    'No'
                ],
                input_Associated_Airport: '',
                shuttleOptions: [
                    'Yes',
                    'No'
                ],
                status: ['Active'],
                statusItems: ['Active', 'Inactive'],
                input_rangeHotelCost: [0, 400],
                input_maxHotelCost: 400,
                input_minHotelCost: 0
			};

		}, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Countries',
                'get_AirportTaxes',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
				'actn_set_filterResources_searchTerm',
                'actn_call_getResourcesOfDepartment',
                'actn_set_filterHotels_searchTerm'
			]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate()
            *
            * Desc: Check if Form is valid. Then From/To Checks. If so ... Call.
            * Note: Mapping bases because bases comes as array oj objects, and
            * Note: we only need idAirport of each object.
            *
            */
            onValidate: function() {

                let me = this,
                    searchTerms = null,
                    mappedShuttle = [],
                    mappedStatus = [];


                me.$toc('>>> views/hotels/components/core/FilterMenue.vue >>> onValidate');
                this.menu = false;

                if(this.input_shuttle !== null) {
                    mappedShuttle = this.input_shuttle.map((shuttle) => {
                        if(shuttle === 'Yes') {
                            return true;
                        } else {
                            return false;
                        }
                    })
                }

                if(this.status.length > 0) {
                    mappedStatus = this.status.map((status) => {
                        if(status === 'Active') {
                            return true;
                        } else {
                            return false;
                        }
                    })
                }

                searchTerms = {
                    country: this.input_country !== null && this.input_country !== undefined && this.input_country !== '' ? this.input_country.id : '',
                    city: this.input_city !== null ? this.input_city : '',
                    associatedAirport: this.input_Associated_Airport !== null && this.input_Associated_Airport !== undefined && this.input_Associated_Airport !== '' ? this.input_Associated_Airport.aptCode : '',
                    shuttle: mappedShuttle !== null ? mappedShuttle : [],
                    status: mappedStatus,
                    minHotelCost: this.input_rangeHotelCost[0],
                    maxHotelCost: this.input_rangeHotelCost[1]
                };


                this.actn_set_filterHotels_searchTerm(searchTerms);

            }, // eof onValidate()



            /*******************************************************************
            * onRefresh()
            *
            * Desc: Check if Form is valid. Then From/To Checks. If so ... Call.
            * Note: Mapping bases because bases comes as array oj objects, and
            * Note: we only need idAirport of each object.
            *
            */
            onDblClick_Refresh: function() {

                let me = this;


                me.$toc('>>> views/people/components/core/FilterMenue.vue >>> onDblClick_Refresh');
                this.menu = false;

                this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: false });
                this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: true });

            }, // eof onDblClick_Refresh()

        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 0px !important; /* 26px */
    }

    .v-label {
        font-size: 14px !important; /* 16px */

    }

    .v-select.v-select--chips input {
        min-height: 42px;
    }

    .v-btn__content {
        font-size: 12px;
    }


    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>
